import { createRouter, createWebHistory } from 'vue-router'
import store from "../store/index";

import ChangeLayout from "@/layouts/ChangeLayout";
import MainLayout from "@/layouts/MainLayout";
import RepairLayout from "@/layouts/RepairLayout";
import ServiceLayout from "@/layouts/ServiceLayout";
import AppRepairBoiler from "@/components/AppRepairBoiler";
import AppRepairHeatchanger from "@/components/AppRepairHeatchanger";
import AppChangeInformation from "@/components/AppChangeInformation";
import AppChangePrice from "@/components/AppChangePrice";
import ProtectionLayout from "@/layouts/ProtectionLayout";
import ControlLayout from "@/layouts/ControlLayout";
import MontageLayout from "@/layouts/MontageLayout";
import AppMontageCopper from "@/components/AppMontageCopper";
import AppMontagePlastic from "@/components/AppMontagePlastic";
import AppServicePrice from "@/components/AppServicePrice";
import AppServiceInformation from "@/components/AppServiceInformation";
import DocumentsLayout from "@/layouts/DocumentsLayout";
import QuestionsLayout from "@/layouts/QuestionsLayout";
import AuthLayout from "@/layouts/AuthLayout";
import AdminLayout from "@/layouts/AdminLayout";
import UserLayout from "@/layouts/UserLayout";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: MainLayout,
    meta: { // любые данные, которые мы хотим добавить для страницы
      layout: 'main', // layout который будет показываться на этой странице
    }
  },
  {
    path: '/control',
    name: 'control',
    component: ControlLayout,
  },
  {
    path: '/change',
    name: 'change',
    component: ChangeLayout,
    children: [
      {
        path: 'changeInformation',
        component: AppChangeInformation,
      },
      {
        path: 'changePrice',
        component: AppChangePrice,
      },
    ],
  },
  {
    path: '/repair',
    name: 'repair',
    component: RepairLayout,
    children: [
      {
        path: 'repairBoiler',
        component: AppRepairBoiler,
      },
      {
        path: 'repairHeatchanger',
        component: AppRepairHeatchanger,
      },
    ],
    meta: {
      layout: 'repair',
    }
  },
  {
    path: '/service',
    name: 'service',
    component: ServiceLayout,
    children: [
      {
        path: 'serviceInformation',
        component: AppServiceInformation,
      },
      {
        path: 'servicePrice',
        component: AppServicePrice,
      },
    ],

  },
  {
    path: '/protection',
    name: 'protection',
    component: ProtectionLayout,
  },
  {
    path: '/montage',
    name: 'montage',
    component: MontageLayout,
    children: [
      {
        path: 'copperPipe',
        component: AppMontageCopper,
      },
      {
        path: 'plasticPipe',
        component: AppMontagePlastic,
      },
    ],
  },
  {
    path: '/documents',
    name: 'documents',
    component: DocumentsLayout,
  },
  {
    path: '/questions',
    name: 'questions',
    component: QuestionsLayout,
  },
  {
    path: '/auth',
    name: 'auth',
    component: AuthLayout,
  },
  {
    path: '/user',
    name: 'user',
    component: UserLayout,
    meta: {
      auth: true,
      role: 'USER'
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminLayout,
    meta: {
      auth: true,
      role: 'ADMIN'
    }
  },
  {
    path: '/request/:id',
    name: 'Request',
    component: () => import('../components/ui/Request.vue'),
    meta: {
      auth: true,
    }
  },
  {
    path: '/user/:id',
    name: 'User',
    component: () => import('../components/ui/User.vue'),
    meta: {
      auth: true,
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active'
})

router.beforeEach((to, from, next) => {

  const role = store._state.data.auth.role

  if ((to.path === '/user' || to.path === '/admin') && role===null) {
    return false
  }

  if ((to.path === '/admin') && role==='USER') {
    return false
  }

  if ((to.path === '/user') && role==='ADMIN') {
    return false
  }

   if (to.path === '/auth' && role === 'USER') {
    next('/user')
  } else if (to.path === '/auth' && role === 'ADMIN') {
    next('/admin')
  }
  else {
    next()
  }
})

router.afterEach((to, from) => {
  if (!((from.path === '/montage/plasticPipe' && to.path === '/montage/copperPipe') || (from.path === '/montage/copperPipe' && to.path === '/montage/plasticPipe'))) {
    window.scrollTo(0,-1000)
  }
})

export default router

